import React, { Component } from 'react';
import Select from 'react-select';

export default class CreateSession extends Component {
  render() {
    return (
    <div className="card">
      <div className="card-header">
        <strong>New Production Session</strong>
      </div>
      <div className="card-block">
        <form>

          <div className={`form-group ${(this.props.errors.indexOf('station') !== -1) ? "has-danger" : ""}`}>
            <label className="col-sm-4 col-form-label" htmlFor="select">Station</label>
            <div className="col-sm-8">
              <select id="select" name="select" className={(this.props.errors.indexOf('station') !== -1) ? "form-control form-control-danger" : "form-control"} size="1" onChange={this.props.onStationChange}>
                <option value="">Please select station</option>
                  {this.props.stations.map((station,index) => {
                        return(<option value={station.id} key={station.id}>{station.name}</option>)
                      })
                  }
              </select>
            </div>
            {(this.props.errors.indexOf('station') !== -1)? <em id="firstname-error" className="error form-control-feedback">Please select station</em> : <em></em>}
          </div>
          <div className={`form-group ${(this.props.errors.indexOf('items') !== -1) ? "has-danger" : ""}`}>
            <label className="col-sm-8 col-form-label" htmlFor="select">Optionally, choose a recipe to produce</label>
            <div className="col-sm-8">
              <Select
                name="form-field-name"
                matchProp="item_name"
                labelKey="item_name"
                options={this.props.recipes.list}
                isLoading={this.props.recipes.loading}
                onChange={this.props.onRecipeChange}
                onInputChange={this.props.searchRecipes}
                value={this.props.recipeValue}
                valueKey='id'
                placeholder={'Please select a recipe'}
                getOptionLabel={(opt) => { return opt.item_name }}
                getOptionValue={(opt) => { return opt.id }}
                filterOption={() => (true)}
              />
            </div>
          </div>

        </form>
      </div>
      <div className="card-footer">
        <button type="submit" className="btn btn-primary" onClick={this.props.submitSession}> Submit</button>
        <button type="reset" className="btn btn-danger" onClick={this.props.cancelSession}> Cancel </button>
      </div>
    </div>
    );
  }
}
